<template>
  <div
    class="  px-10 mt-7">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row>
            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/invested.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #718EBF;" class="fs-16 mb-1">Total Invested Amount</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">$150,000</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/investments.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #718EBF;" class="fs-16 mb-1">Number of Investments</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">1,250</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/rate.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #718EBF;" class="fs-16 mb-1">Rate of Return</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">+5.80%</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="6">
              <div class="fs-22 mb-5 color-dark-blue font-weight-medium">
                Yearly Total Investment              
              </div>

              <v-card flat class="pa-5 border-radius-card">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 350px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 fs-17 color-light-blue">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-card-text>
                
                <div id="chart" v-if="!process.load && yearly">
                  <apexchart type="line" height="350" :options="yearly.chartOptions" :series="yearly.series"></apexchart>
                </div>
              </v-card>

            </v-col>

            <v-col cols="6">
              <div class="fs-22 mb-5 color-dark-blue font-weight-medium">
                Monthly Revenue              
              </div>

              <v-card flat class="pa-5 border-radius-card">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 350px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 fs-17 color-light-blue">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-card-text>
                
                <div id="chart" v-if="!process.load && monthly">
                  <apexchart type="line" height="350" :options="monthly.chartOptions" :series="monthly.series"></apexchart>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="7">
              <div class="fs-22 mb-3 color-dark-blue font-weight-medium">
                My Investment              
              </div>

              <v-card
                flat
                class="pa-5 py-0 mb-4 border-radius-card"
                v-for="(item, i) in bank"
                :key="i">
                <v-row class="align-center">
                  <v-col cols="6">
                    <div class="d-flex align-center">
                      <div class="mr-4">
                        <v-avatar class="my-1" size="55" tile>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            :src="item.image_url"
                            class="">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>
                      <div>
                        <div>
                          <div style="color: #232323;" class="fs-16 font-weight-medium">{{ item.title }}</div>
    
                          <div class="color-light-blue fs-15">{{ item.type }}</div>
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="3">
                    <div>
                      <div style="color: #232323;" class="fs-16 font-weight-medium">{{ item.envestment }}</div>

                      <div class="color-light-blue fs-15">Envestment Value</div>
                    </div>
                  </v-col>

                  <v-col cols="3">
                    <div>
                      <div class="fs-16 font-weight-medium" :style="parseInt(item.return) > 0 ? 'color: #41D4A8;' : 'color: #FF4B4A;'">{{ item.return }}%</div>

                      <div class="color-light-blue fs-15">Return Value</div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="5">
              <div class="fs-22 mb-3 color-dark-blue font-weight-medium">
                Active Loans Overview
              </div>

              <v-card
                flat
                class="pa-5 pb-6 border-radius-card">
                <table style="width: 100%;">
                  <tr>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">SL No</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Name</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Price</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Return</th>
                  </tr>

                  <tr v-for="(item, index) in trending" :key="index">
                    <td style="padding: 8px 0px;" class="fs-16 color-dark-blue">{{ index+1 }}</td>
                    <td style="padding: 8px 0px;" class="fs-16 color-dark-blue">{{ item.title }}</td>
                    <td style="padding: 8px 0px;" class="fs-16 color-dark-blue">{{ item.price }}</td>
                    <td style="padding: 8px 0px;" class="fs-16" :style="parseInt(item.return) > 0 ? 'color: #41D4A8;' : 'color: #FF4B4A;'">{{ item.return }}</td>
                  </tr>
                </table>
              </v-card>
            </v-col>
          </v-row>


        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        bank: [
          {
            image_url: require('@/assets/icon/iphone.png'),
            title: 'Apple Store',
            type: 'E-commerce, Marketplace',
            envestment:'$54,000',
            return: '+16'
          },
          {
            image_url: require('@/assets/icon/google.png'),
            title: 'Samsung Mobile',
            type: 'E-commerce, Marketplace',
            envestment:'$24,000',
            return: '-4'
          },
          {
            image_url: require('@/assets/icon/tesla.png'),
            title: 'Tesla Motors',
            type: 'Electric Vehicles',
            envestment:'$8,000',
            return: '+25'
          }
        ],

        trending: [
          {
            title: 'Trivago',
            price: '$520',
            return: '+5'
          },
          {
            title: 'Canon',
            price: '$480',
            return: '+10'
          },
          {
            title: 'Uber Food',
            price: '$350',
            return: '-3'
          },
          {
            title: 'Nokia',
            price: '$940',
            return: '+2'
          },
          {
            title: 'Tiktok',
            price: '$670',
            return: '+12'
          }
        ],
        yearly: {
          series: [{
              name: "Yearly Total Investment",
              data: [10, 41, 35, 51, 49, 62]
          }],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            colors: ['#FCAA0B'],
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['2016', '2017', '2018', '2019', '2020', '2021'],
            }
          },
        },
        monthly: {
          series: [{
              name: "Monthly Revenue",
              data: [10, 20, 35, 15, 49, 62]
          }],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            // forecastDataPoints: {
            //   count: 7
            // },
            stroke: {
              width: 5,
              curve: 'smooth'
            },
            colors: ['#16DBCC'],
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: ['2016', '2017', '2018', '2019', '2020', '2021'],
            }
          },
        },
        process: {
          load: true
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },


      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      
    },

    watch: {

    },
    mounted () {
      setTimeout(() => {
        this.process.load = false
      }, 1000)
    },
    methods: {
      
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;

    /* background-color: #718EBF; */
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  }


  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
</style>